{
  "google-salon-details-page": {
    "buttons": {
      "be-partner": "PARTNER WERDEN",
      "request": "ANFORDERN"
    },
    "text": {
      "is-customer-question": "Sind Sie Kunde des Salons?",
      "is-customer-hint": "Wenn Sie eine Online-Buchungsfunktion für den Salon wünschen, teilen Sie uns dies bitte mit und wir werden uns mit dem Salonbesitzer in Verbindung setzen.",
      "is-owner-question": "Sind Sie Inhaber des Salons?",
      "is-owner-hint": "Werden Sie Partner bei uns und entdecken Sie unsere unbegrenzten Funktionen mit einem großen Anfangsangebot!",
      "request-sent": "IHRE ANFRAGE WURDE GESENDET"
    }
  }
}
